"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettingsOperation = void 0;
exports.getSettingsOperation = {
    method: 'GET',
    name: 'getSettings',
    id: 'GetSettings',
    groupName: 'project',
    urlPathPattern: '/settings',
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest() {
    return undefined;
}
function deserializeRequest() {
    return {};
}
//# sourceMappingURL=getSettingsOperation.js.map